import React from 'react';

const Footer = () => {
  return (
    <footer className='bg-black py-8 text-white text-center'>
          <div className="container mx-auto">
            Copyright 2023 &copy; All rights reserved by Tahjib Hossain Leon
          </div>
    </footer>)
    ;
};

export default Footer;
